export function createElement(tag) {
    return document.createElementNS("http://www.w3.org/2000/svg", tag);
}
//# sourceMappingURL=createElement.js.map